import React from 'react';

import { Telemetry } from '~src/commonInfra/services/Telemetry';
import { TelemetryEvents, VPCFeatureEPTEvent } from '~src/commonInfra/telemetryEvents/TelemetryEvents';

export function useEPT(featureName: string, done: boolean, dataSize: number) {
    const startTime = React.useRef<Date>(new Date());
    const alreadyRecorded = React.useRef(false);

    React.useEffect(() => {
        if (done && startTime.current && alreadyRecorded.current === false) {
            const duration = (new Date()).getTime() - startTime.current.getTime();
            Telemetry.sendEvent<VPCFeatureEPTEvent>({
                type: TelemetryEvents.VPCFeatureEPT,
                feature_name: featureName,
                duration,
                data_size: dataSize
            });
            alreadyRecorded.current = true;
        }
    }, [done, featureName, dataSize, startTime, alreadyRecorded]);
}